import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import DropDown from "@components/dropDowns/dropDown/DropDownComponent";
import { States } from "@helper/Constants";
import { getTranslatedTextIfNeeded } from "@shared/InternationalizationTextUtils";
import { getMilkDonationSelectedLocationText, getMilkDonationStateFieldUiMode } from "@service/MilkDonation/MilkDonationStateSync";

const milkDonationStateDropdownItems = States.map((s) => ({ text: s.title, sequenceId: `md-state-${s.name}` }));

function MilkDonationStateTextQuestionComponent({ question, answer, onAnswer, selectedTopic }) {
    const { t } = useTranslation();
    const [value, setValue] = useState(answer.userAnswer || "");
    const [isMounted, setIsMounted] = useState(false);

    const onAnswerRef = useRef(onAnswer);
    const selectedTopicRef = useRef(selectedTopic);
    const questionRef = useRef(question);
    const answerRef = useRef(answer);

    useEffect(() => {
        onAnswerRef.current = onAnswer;
        selectedTopicRef.current = selectedTopic;
        questionRef.current = question;
        answerRef.current = answer;
    });

    const milkLocationText = getMilkDonationSelectedLocationText(selectedTopic);
    const milkStateUiMode = getMilkDonationStateFieldUiMode(milkLocationText);

    useEffect(() => {
        setValue(answer.userAnswer || "");
    }, [answer.userAnswer]);

    useEffect(() => {
        if (milkStateUiMode === "default" && isMounted) {
            const timer = setTimeout(() => {
                const a = answerRef.current;
                if (value !== a.userAnswer) {
                    a.userAnswer = value;
                    onAnswerRef.current(selectedTopicRef.current, questionRef.current, a);
                }
            }, 400);
            return () => clearTimeout(timer);
        }
        setIsMounted(true);
    }, [value, milkStateUiMode, isMounted]);

    const inputId = `milk-state-${answer.sequenceId}`;

    if (milkStateUiMode === "mappedReadonly") {
        return (
            <div key={inputId}>
                <input
                    id={getTranslatedTextIfNeeded(question.text)}
                    type="text"
                    readOnly
                    className="milk-donation-state-readonly"
                    value={value}
                    aria-readonly="true"
                    aria-label={getTranslatedTextIfNeeded(question.text)}
                />
            </div>
        );
    }

    if (milkStateUiMode === "otherSelect") {
        const selectedStateItem = milkDonationStateDropdownItems.find((item) => item.text === value) || null;
        return (
            <div key={inputId}>
                <DropDown
                    items={milkDonationStateDropdownItems}
                    selectedItem={selectedStateItem}
                    placeholder={t("Select")}
                    onChange={(item) => {
                        const v = item.text;
                        setValue(v);
                        answer.userAnswer = v;
                        onAnswer(selectedTopic, question, answer);
                    }}
                />
            </div>
        );
    }

    return (
        <input
            id={getTranslatedTextIfNeeded(question.text)}
            key={inputId}
            type="text"
            placeholder={getTranslatedTextIfNeeded(answer.text)}
            value={value}
            onChange={(event) => setValue(event.target.value.trimStart())}
        />
    );
}

export default MilkDonationStateTextQuestionComponent;
